import { Text3D, useGLTF, Center } from "@react-three/drei";
import { animated } from "@react-spring/three";
import BackdoToken from "../moveTokens/BackdoToken";
import { useAtom } from 'jotai';
import { languageAtom } from '../GlobalState';
import translations from '../dictionaries/translations';

export default function BackdoAlert({ position, rotation, scale, skip='false' }) {
  const [language] = useAtom(languageAtom);
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

  function NoTokenAlert(props) {
    return <group {...props}>
      <mesh
        castShadow
        receiveShadow
        scale={[2.1, 0.065, 0.8]}
      >
        <cylinderGeometry args={[1, 1, 1, 64]}/>
        <meshStandardMaterial color='black' opacity={0.9} transparent/>
      </mesh>
      <Center position={[0, 0.3, 0.1]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          size={0.45}
          height={0.01}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
        >
          {translations.alerts.noToken[language]}
          <meshStandardMaterial color="orange"/>
        </Text3D>
      </Center>
    </group>
  }
  return (
    <animated.group position={position} rotation={rotation} scale={scale}>
      <mesh
        castShadow
        receiveShadow
        scale={[2.1, 0.065, 0.8]}
      >
        <cylinderGeometry args={[1, 1, 1, 64]}/>
        <meshStandardMaterial color='black' opacity={0.9} transparent/>
      </mesh>
      <Center position={[-0.5, 0.3, 0.1]} key={Math.random()}>
        <Text3D
          font={fontUrl}
          size={0.45}
          height={0.01}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
        >
          {translations.alerts.backdo[language]}
          <meshStandardMaterial color="orange"/>
        </Text3D>
      </Center>
      <BackdoToken rotation={[0, Math.PI/2, 0]} position={[1.2, 0, 0]}/>
      { skip && <group>
        <NoTokenAlert position={[0, 0, 2]}/>
      </group> }
    </animated.group>
  )
}